<template>
    <ModalBase modal-type="info" @close="$emit('close')">
        <template #header>
            {{ $t('component.dialog.information_request.title') }}
        </template>
        <template #body>
            <div class="w-full flex">
                <div v-if="error" class="w-3/3 text-red-600 font-bold text-center">
                    {{ error }}
                </div>
            </div>
            <div class="w-full text-center mb-1">
                {{ $t('component.dialog.information_request.explanation') }}
            </div>
            <div class="w-full flex">
                <div class="w-1/3 text-right">
                    <p class="m-1">{{ $t('component.dialog.information_request.notes') }}</p>
                </div>
                <div class="w-2/3">
                    <div class="m-1">
                                <textarea v-model="note.value"
                                          class="border border-gray-500 rounded py-2 pl-2 w-full"
                                          maxlength="500"
                                          :class="{ 'border-red-600' : note.error }"
                                          rows="10"
                                ></textarea>
                        <div class="text-xs text-gray-600">{{
                            $t('component.dialog.information_request.textarea.max_length')}}
                        </div>
                        <label class="text-red-600"
                               v-if="note.error !== ''">
                            {{ note.error }}
                        </label>
                    </div>
                </div>
            </div>
        </template>
        <template #footer-without-padding>
            <div class="w-full flex justify-end px-4 pb-4">
                <p class="underline inline mr-4 cursor-pointer" @click="$store.commit('app/hideInfoRequestDialog')">
                    {{ $t('component.dialog.information_request.close') }}
                </p>
                <button @click="requestInformation"
                        class="font-bold bg-blue-500 text-white px-4 py-1">
                    {{ $t('component.dialog.information_request.send') }}
                </button>

            </div>
        </template>
    </ModalBase>
</template>

<script>
    import ModalBase from "@/components/shared/ModalBase";
    import {MissionService} from "@/services/mission.service";
    import {de, pl} from 'vuejs-datepicker/dist/locale';

    export default {
        name: "InformationRequestDialog",
        props: ['mission'],
        components: {
            ModalBase
        },
        data() {
            return {
                note: {
                    value: '',
                    error: ''
                },
                error: '',
            }
        },
        computed: {
            lang() {
                if (this.$i18n.locale === 'de') {
                    return de;
                } else if (this.$i18n.locale === 'pl') {
                    return pl;
                }

                return de;
            }
        },
        methods: {
            requestInformation() {
                if (this.note.value.length > 500) {
                    this.note.error = this.$t('component.dialog.information_request.note.error');
                    return;
                }

                try {
                    MissionService.requestFurtherInformation(this.mission, this.note.value).then(() => {
                        this.$store.commit('app/hideInfoRequestDialog');
                    }).catch(() => {
                        this.error = this.$t('component.dialog.information_request.error')
                    });
                } catch (e) {
                    this.error = this.$t('component.dialog.information_request.error')
                }
            }
        }
    }
</script>

<style scoped>

</style>